import React, {type ReactNode} from 'react';

export type LabelWidth = number | string;
export type FormGroupContextProps = {
  ariaDescribedBy?: string;
  baseId?: string;
  isError?: boolean;
  isRequired?: boolean;
  feedbackId?: string;
  helpTextId?: string;
  labelId?: string;
  htmlFor?: string;
  isHorizontal?: boolean;
  labelWidth?: LabelWidth;
  /**
   * Used internally for FormGroup
   */
  registerControlId: (id?: string, preferredId?: string) => void;
};

/**
 * The context to coordinate with controls (e.g. TextInput) and complementary
 * form elements (e.g. FormHelpText).
 */
export const FormGroupContext = React.createContext<FormGroupContextProps>({
  ariaDescribedBy: undefined,
  baseId: undefined,
  isError: undefined,
  feedbackId: undefined,
  helpTextId: undefined,
  htmlFor: undefined,
  isHorizontal: false,
  isRequired: undefined,
  labelId: undefined,
  labelWidth: 80,
  registerControlId: () => undefined,
});

export type FormGroupProviderProps = {
  /**
   * The content for FormGroup.
   */
  children?: ReactNode;
  /**
   * Renders the error state for form elements within FormGroup.
   */
  isError?: boolean;
  /**
   * Renders the label and form elements horizontally.
   */
  isHorizontal?: boolean;
  /**
   * An accessible way to indicate that a form field is required
   */
  isRequired?: boolean;
  /**
   * The id for the FormGroup.
   */
  id?: string;
  /**
   * The width of the label for the FormGroup.
   */
  labelWidth?: LabelWidth;
};
